"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var contexts_1 = require("../../../contexts");
var SubMenu_1 = tslib_1.__importDefault(require("../SubMenu"));
var SubNavigationWrapper_1 = tslib_1.__importDefault(require("./SubNavigationWrapper"));
var InlineNavigationWrapper_1 = tslib_1.__importDefault(require("./InlineNavigationWrapper"));
var NavButton_1 = tslib_1.__importDefault(require("./NavButton"));
var MenuItem_1 = tslib_1.__importDefault(require("./MenuItem"));
var base_1 = require("../../../themes/base");
var MENU_FIXED_WIDTH = 500;
var MENU_FIXED_HEIGHT = 282;
var ContentSection = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  height: 100%;\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  ", "\n  height: 100%;\n  ", "\n"])), function (_a) {
    var currentSize = _a.currentSize;
    return (currentSize === 'xs' ? '' : "border: 1px solid " + base_1.colors.border.light + ";");
}, function (_a) {
    var currentSize = _a.currentSize;
    return "padding: " + base_1.spacing().small + " " + (currentSize === 'xs' ? base_1.spacing().xxlarge : base_1.spacing().xlarge) + ";";
});
var NavigationBar = function (_a) {
    var navSections = _a.navSections;
    var currentSize = react_1.useContext(contexts_1.ResponsiveContext);
    var _b = react_1.useState(-1), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var _c = react_1.useState(null), targetNode = _c[0], setTargetNode = _c[1];
    var isNavigationOpen = selectedIndex !== -1;
    var isSmallScreen = currentSize === 'xs' || currentSize === 'sm';
    var subMenuLeft = targetNode ? targetNode.offsetLeft : 0;
    var subMenuContent = navSections[selectedIndex] && navSections[selectedIndex].content;
    var handleClose = function () {
        setSelectedIndex(-1);
        setTimeout(function () {
            setTargetNode(null);
        }, base_1.base.global.transition.durationMS);
    };
    var content = (react_1.default.createElement(react_1.default.Fragment, null,
        navSections.map(function (_a, index) {
            var header = _a.header, shortHeader = _a.shortHeader, content = _a.content, routePath = _a.routePath, onClick = _a.onClick;
            var handleFlyout = function (e) {
                if (selectedIndex === index) {
                    handleClose();
                }
                else {
                    setSelectedIndex(index);
                    setTargetNode(e.currentTarget);
                }
            };
            return (react_1.default.createElement(NavButton_1.default, tslib_1.__assign({ key: "nav-" + index, isSmallScreen: isSmallScreen, isSelected: selectedIndex === index }, (content.length || onClick
                ? {
                    onClick: function (e) {
                        if (onClick) {
                            onClick(e);
                        }
                        if (content.length) {
                            handleFlyout(e);
                        }
                    }
                }
                : { to: routePath })), isSmallScreen ? shortHeader || header : header));
        }),
        react_1.default.createElement(SubMenu_1.default, { isOpen: isNavigationOpen, left: subMenuLeft, width: MENU_FIXED_WIDTH, height: MENU_FIXED_HEIGHT, currentSize: currentSize, onClose: handleClose },
            react_1.default.createElement(ContentSection, { currentSize: currentSize }, subMenuContent &&
                subMenuContent.map(function (_a, subIndex) {
                    var routePath = _a.routePath, title = _a.title;
                    return (react_1.default.createElement(MenuItem_1.default, { key: "sub-nav-" + subIndex, routePath: routePath, onClick: handleClose }, title));
                })))));
    if (currentSize === 'xs') {
        return react_1.default.createElement(SubNavigationWrapper_1.default, { isNavigationOpen: isNavigationOpen }, content);
    }
    return react_1.default.createElement(InlineNavigationWrapper_1.default, null, content);
};
exports.default = NavigationBar;
var templateObject_1;
//# sourceMappingURL=NavigationBar.js.map